/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Toast from './sub_components/toast';
import * as eventService from '../services/eventService'
import * as marketService from '../services/marketService'
import * as currentBetsService from '../services/currentBetsService'
import * as tvService from '../services/tvService'
import * as providerIframeService from '../services/providerIframeService'
import * as apiUserService from '../services/apiUserService'
import * as userService from '../services/userService'
import * as eventPnLReportService from '../services/eventPnLReportService'
import * as utilService from '../services/utilService'
import ScoreBoard from './sub_components/marketanalysis/scoreboard'
import SoccerBoard from './sub_components/marketanalysis/soccerBoard'
import TennisBoard from './sub_components/marketanalysis/tennisBoard'
import KabaddiBoard from './sub_components/marketanalysis/kabaddiBoard'
import ElectionBoard from './sub_components/marketanalysis/electionBoard'
import WebMarket from './sub_components/marketanalysis/webmarket'
import FancyMarket from './sub_components/marketanalysis/fancymarket'
import ExpoPopup from './sub_components/marketanalysis/expoPopup'
import Currency from './sub_components/currency'
import EventUnsettledBets from './sub_components/eventUnsettledBets'
import UserMarketBook from './sub_components/userMarketBook'
import AverageMarketBook from './sub_components/averageMarketBook'
import MarketBetLock from './sub_components/marketBetLock'
import socketIOClient from "socket.io-client";
// import { liveSocketEndPoint } from "../configs/const"
import * as stringParser from "../util/string.util"
import { scoreFormatDate } from '../util/date.util'
import { BASE_IMAGE_PATH, SOCKET_ROOT as liveSocketEndPoint } from '../configs/api'
import { FLASH_TV_URL, NANO_TV_URL, SHOW_LMT_IFRAME, SHOW_CRICKET_SCORE_IFRAME } from '../configs/commonConfigs'
import { BRANDLOGOFILENAME } from '../configs/authSignupConfig'
import GraphicScore from './sub_components/marketanalysis/graphicScore';
import reactCsv from 'react-csv';
import EventPnLReportMarketOrderModel from './sub_components/eventPnLReportMarketOrderModel';
import SettledMarketsPnLModel from './sub_components/settledMarketsPnLModel';
import AgentCuttingModal from './sub_components/agentCuttingModal';
import * as agentOrdersService from '../services/agentOrdersService';
import ComboBook from './sub_components/marketanalysis/comboBook'
import WinnerOdds from './sub_components/marketanalysis/winnerodds';

let accessToken = !!localStorage.getItem("userAuthDetail") ? JSON.parse(localStorage.getItem("userAuthDetail")).token : "";
let socket = null;
let beep = null;
let dataUpdate
class SportAnalysisUsers extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         showPopupBets: false,
         showPopupUserBook: false,
         showPopupBetsLock: false,
         showPopupFancyBook: false,
         showBetsLockMenu: false,
         showFancyLockMenu: false,
         showMarketBetDetail: false,
         showUserDetailPopup: false,
         betsClientsIP: "",
         betsAmountFrom: "",
         betsAmountTo: "",
         userBetDelay: "",
         masterPassword: "",
         userBetLock: false,
         marketBetDetail: [],
         marketuserDetail: [],
         userDetail: [],
         usermktData: {},
         eventData: {},
         fancyMarkets: [],
         lineMarkets: [],
         oddsMarkets: [],
         matched_bet: [],
         matched_bet_filter: [],
         showExpo: false,
         lineExpoMktId: null,
         lineExpo: {},
         lineAgentExpo: {},
         lineName:"",
         tvUrl: "",
         streamName: "",
         tvIP: "",
         toastMsg: "",
         toastType: "",
         showToast: false,
         bets_data: [],
         accounts: "",
         frontData: {},
         betListLimit: 20,
         betFilter: "",
         mktFeedBooks: {},
         openUserBook: false,
         bookMkt: {},
         agentCuttingMkt:{},
         oddCount: 0,
         bmCount: 0,
         fancyCount: 0,
         mktOrderCount: {},
         underOverCount: 0,
         newPopupData: false,
         deactivatMarkets: [],
         deactivatOrders: [],
         eventDetail: {},
         tvShow: false,
         fancyFilter: "all",
         showFancy: true,
         hideMkt: [],
         beepAllow: false,
         isBeepPlaying: false,
         avgBookPopup: false,
         avgMarket: {},
         avgCurrRunnerId: "",
         marketExpos: {},
         marketAgentExpos: {},
         showMarketBetLock: false,
         marketMsg: {},
         betLockMkt: {},
         isGraphicScore: false,
         subscribedMarkets: [],
         scoreUrl: "",
         expoPrice: null,
         isEventUpdate: false,
         isVisible: true,
         updateProps: false,
         consoleRights: false,
         onShowPnLReportMarketPopup:false,
         pnLReportMarkets: null,
         sportAnalysisEventDetails: null,
         notLineRunnerIdList: {},
         isComboBookOpen:false,
         runners: [],
         score_id: "",
         cricketScoreUrl: "",
         lmtScoreUrl: "",
         lmtTheme: "white-red-theme",
         isDesktop: false
      };
   }
   async resultDeclered(type, payload) {
      let deactivatMarkets = this.state.deactivatMarkets
      let deactivatOrders = this.state.deactivatOrders
      if (type === "market") {
         if (!!payload && !!payload.marketId) {
            deactivatMarkets.push(payload.marketId)
         }
      } else if (type === "order") {
         if (!!payload && !!payload.orderId) {
            deactivatOrders.push(payload.orderId)
         }
      } else if (type === "rollback") {
         if (!!payload && !!payload.marketId) {
            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
               deactivatMarkets.splice(index, 1)
            }
            this.onSubmitForm()
         }
      } else if (type === "marketvoid") {
         if (!!payload && !!payload.marketId) {
            deactivatMarkets.push(payload.marketId)
         }
      }
      this.setState({ deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders }, async () => {
         let expos = await marketService.getEventResults(this.props.match.params.event_id)
         expos = expos.items
         this.calculateCount(expos)
      })
   }
   async componentDidMount() {
      let self = this;
      
      if (window.screen.width >= 992){
         this.setState({isDesktop:true})
      }

      document.addEventListener("visibilitychange", function () {
         if (document.hidden) {
            self.setState({ isVisible: false })
         } else {
            self.setState({ isVisible: true, updateProps: true },
               () => {
                  self.setState({ updateProps: false })
               }
            )
         }
      });

      beep = document.getElementById("beepplay");
      let userData = localStorage.getItem("tokenData")
      let mktExpos = {}
      let mktAgentExpos = {}
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         this.props.history.push("/auth")
      }
      
      const consoleRights = !!localStorage.getItem('userAccData') && !!JSON.parse(localStorage.getItem('userAccData')) && !!JSON.parse(localStorage.getItem('userAccData')).parents? JSON.parse(localStorage.getItem('userAccData')).parents.includes("office") : false;
      this.setState({ accounts: userData.sub, consoleRights: consoleRights },
         () => {
            this.onSubmitForm()
         }
      )

      if (accessToken !== "" && accessToken) {
         socket = socketIOClient(liveSocketEndPoint, {
            query: 'token=' + accessToken,
            transports: ["websocket"]
         });
      }

      let eventData = await eventService.getUserEventById(this.props.match.params.event_id)

      // if(!!eventData && !!eventData.catalogues && eventData.catalogues.length>0){
      //    const forSequenceMkt = !!eventData.catalogues[0] && eventData.catalogues[0].bettingType === "ODDS" && eventData.catalogues[0].marketType === "MATCH_ODDS" ? eventData.catalogues[0] : !!eventData.catalogues[0] && eventData.catalogues[0].bettingType === "BOOKMAKER" && eventData.catalogues[0].marketType === "BOOKMAKER" ? eventData.catalogues[0] : null;
      //    if(!!forSequenceMkt){
      //       let notLineRunnerIdLst = this.state.notLineRunnerIdList;
      //       for(const rnr of forSequenceMkt.runners ){
      //          notLineRunnerIdLst[rnr.name] = [];
      //       }
      //       for(const mkkt of eventData.catalogues){
      //          if(mkkt.bettingType !==  "LINE" && mkkt.marketType !== "COMPLETED_MATCH" && mkkt.marketType !== "TIED_MATCH" && mkkt.marketType !== "OVER_UNDER_35" && mkkt.marketType !== "OVER_UNDER_25" && mkkt.marketType !== "OVER_UNDER_15" && mkkt.marketType !== "OVER_UNDER_05" && mkkt.marketType !== "TO_WIN_THE_TOSS"){
      //             for(const rnrr of mkkt.runners ){
      //                if(!!notLineRunnerIdLst && !notLineRunnerIdLst[rnrr.name].includes(rnrr.id)){
      //                   notLineRunnerIdLst[rnrr.name].push(rnrr.id);
      //                }
      //             }     
      //          }
      //       }
      //       this.setState({notLineRunnerIdList: notLineRunnerIdLst});
      //    }
      // }

      if(!!eventData && !!eventData.catalogues && eventData.catalogues.length>0){
         let mktindx = -1;
         for(let i=0;i<eventData.catalogues.length;i++){
            if(!!eventData.catalogues[i] && ((eventData.catalogues[i].bettingType === "ODDS" && eventData.catalogues[i].marketType === "MATCH_ODDS") || (eventData.catalogues[i].bettingType === "BOOKMAKER" && eventData.catalogues[i].marketType === "BOOKMAKER"))){
               mktindx = i;
               break;
            }
         }

         let forSequenceMkt;
         if(mktindx>-1){
            forSequenceMkt = eventData.catalogues[mktindx];
         }
         
         if(!!forSequenceMkt){
            let notLineRunnerIdLst = self.state.notLineRunnerIdList;
            if(notLineRunnerIdLst === {} || Object.keys(notLineRunnerIdLst).length === 0){
               for(const rnr of forSequenceMkt.runners ){
                  notLineRunnerIdLst[rnr.name] = [];
               }
            }
            for(const mkkt of eventData.catalogues){
               if(mkkt.bettingType !==  "LINE" && mkkt.marketType !== "COMPLETED_MATCH" && mkkt.marketType !== "TIED_MATCH" && mkkt.marketType !== "OVER_UNDER_35" && mkkt.marketType !== "OVER_UNDER_25" && mkkt.marketType !== "OVER_UNDER_15" && mkkt.marketType !== "OVER_UNDER_05" && mkkt.marketType !== "TO_WIN_THE_TOSS"){
                  for(const rnrr of mkkt.runners ){
                     if(!!notLineRunnerIdLst[rnrr.name.toString().trim()] && !notLineRunnerIdLst[rnrr.name.toString().trim()].includes(rnrr.id)){
                        notLineRunnerIdLst[rnrr.name.toString().trim()].push(rnrr.id);
                     }
                  }     
               }
            }
            self.setState({notLineRunnerIdList: notLineRunnerIdLst, runners: forSequenceMkt.runners});
         }
      }

      let expos = await marketService.getEventResults(this.props.match.params.event_id)
      expos = expos.items
      let agentexpos = await agentOrdersService.getAgentMarketByEventId(this.props.match.params.event_id);
      agentexpos = agentexpos.items

      let tvUrl = !!eventData.metadata && !!eventData.metadata.tvUrl ? eventData.metadata.tvUrl : ""

      //    if ((eventData.eventType.id === "1" || eventData.eventType.id === "2") && tvUrl.includes("ip=")) {
      //       let ipData = await utilService.getClientIp()
      //       tvUrl = tvUrl + ipData.IPv4
      //   }
      let msgs = !!eventData.metadata && !!eventData.metadata.messages ? JSON.parse(eventData.metadata.messages) : {}
      let inActiveMkts = !!eventData.metadata && !!eventData.metadata.inactiveMarkets ? JSON.parse(eventData.metadata.inactiveMarkets) : []

      this.setState({ marketMsg: msgs, score_id: !!eventData.metadata && !!eventData.metadata.scoreUrl ? eventData.metadata.scoreUrl : "" },
         ()=>{
            (SHOW_LMT_IFRAME && !!eventData.eventType && (eventData.eventType.id === "1" || eventData.eventType.id === "2")) && this.lmtScore()
         }
      )
      // setInterval(async () => {
      //    let msgs = await eventService.getEventMktMessages(this.props.match.params.event_id)
      //    this.setState({ marketMsg: msgs })
      // }, 6000)

      this.calculateCount(expos)
      if (eventData.metadata && !!eventData.metadata.score) {
         this.setState({ frontData: JSON.parse(eventData.metadata.score) },
            ()=>{
               (SHOW_CRICKET_SCORE_IFRAME && !!eventData.eventType && eventData.eventType.id === "4") && this.cricketScore()
            }
         )
      }

      if (!eventData.catalogues) {
         return false
      }
      eventData.catalogues = !!eventData.catalogues ? eventData.catalogues.filter((mkt) => {
         return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
      }) : []
      !!eventData.catalogues && Array.prototype.forEach.call(eventData.catalogues, (market, i) => {
         let mkt_exposour = !!expos ? expos.filter((exp) => {
            return exp.marketId === market.marketId
         }) : []
         let mkt_agent_exposour = !!agentexpos ? agentexpos.filter((aexp) => {
            return aexp.marketId === market.marketId
         }) : []
         mktExpos[market.marketId] = mkt_exposour.length > 0 ? mkt_exposour[0] : {}
         mktAgentExpos[market.marketId] = mkt_agent_exposour.length > 0 ? mkt_agent_exposour[0] : {}
         if (!!eventData.metadata && !!eventData.metadata.books) {
            // let mktBook = stringParser.deSrlz("book|" + eventData.metadata.books[market.marketId])
            let mktBookData = JSON.parse(eventData.metadata.books)
            let mktBook = !!mktBookData && !!mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : {}
            eventData.catalogues[i].metadata = {}
            eventData.catalogues[i].metadata.book = mktBook
         } else {
            let baseData = {
               marketId: market.marketId,
               status: "OPEN",
               runners: []
            }
            Array.prototype.forEach.call(eventData.catalogues[i].runners, (rnr) => {
               let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
               baseData.runners.push(data)
            })
            eventData.catalogues[i].metadata = {}
            eventData.catalogues[i].metadata.book = baseData
         }
      })

      var moPos = eventData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
      if (moPos !== -1) {
         let mom = [eventData.catalogues[moPos]]
         eventData.catalogues.splice(moPos, 1)
         eventData.catalogues = mom.concat(eventData.catalogues)
      }
      let fancy_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
         return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE"
      })
      let line_mkts = []
      // let line_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
      //    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && mkt.provider === "BETFAIR" && mkt.bettingType === "LINE" && !!mkt.metadata && !!mkt.metadata.books
      // })
      let odds_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
         return (mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE") && !!mkt.metadata && !!mkt.metadata.book && mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE"
      })

      fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
      let mBets = []

      this.setState({ eventDetail: eventData, eventData: eventData, lineMarkets: line_mkts, matched_bet: mBets, fancyMarkets: fancy_mkts, oddsMarkets: odds_mkts, tvUrl: tvUrl, marketExpos: mktExpos, marketAgentExpos: mktAgentExpos })
      // const orderSocket = socketIOClient(liveSocketEndPoint);
      // orderSocket.on('connect', () => {
      //    orderSocket.emit('order_room', userData.sub + ":" + self.props.match.params.event_id)
      // })
      // orderSocket.on("order_room", data => {
      //    let bets_data = self.state.bets_data
      //    data.side = data.side === "BACK" ? 0 : 1
      //    let newData = [data]
      //    newData = newData.concat(bets_data)

      //    if(this.state.beepAllow){
      //       beep.play()
      //    }

      //    if (data.marketBettingType === "ODDS") {
      //       self.setState({ bets_data: [] }, () => {
      //          if (data.marketType === "MATCH_ODDS" || data.marketType === "WINNER") {
      //             self.setState({ bets_data: newData, oddCount: self.state.oddCount + 1, newPopupData: true })
      //          } else {
      //             self.setState({ bets_data: newData, underOverCount: self.state.underOverCount + 1, newPopupData: true })
      //          }
      //       })
      //    } else if (data.marketBettingType === "BOOKMAKER") {
      //       self.setState({ bets_data: [] }, () => {
      //          self.setState({ bets_data: newData, bmCount: self.state.bmCount + 1, newPopupData: true })
      //       })
      //    } else if (data.marketBettingType === "LINE") {
      //       self.setState({ bets_data: [] }, () => {
      //          self.setState({ bets_data: newData, fancyCount: self.state.fancyCount + 1, newPopupData: true })
      //       })
      //    }
      // });
      // orderSocket.on('disconnect', () => {
      //    orderSocket.emit('order_room', userData.sub + ":" + self.props.match.params.event_id)
      // })
      beep.addEventListener('ended', (e) => {
         this.setState({
            isBeepPlaying: false
         }, () => {
            // console.log('two - ' + (new Date()).toISOString())
         })
      })
      socket.emit('user_room', userData.sub);
      socket.emit('site_room', userData.sub);
      socket.on("site_room", data => {
         let msg = JSON.parse(data);
         if (!!msg.command && msg.command === "SPORTSBETPLACED") {
            if(!!this.state.lineExpoMktId && this.state.lineExpoMktId === msg.payload.marketId){
               let mktLineExpo = {}
               !!msg.payload.runnersExposure && Array.prototype.forEach.call(Object.keys(msg.payload.runnersExposure),(i) => {
                     mktLineExpo[i] = {}
                     mktLineExpo[i].expo = ((msg.payload.runnersExposure[i].sharingMe))
               })
               this.updateShownExpo(msg.payload.marketId, mktLineExpo)
            }
            let expos = this.state.marketExpos
            data = JSON.parse(data).payload
            if (self.props.match.params.event_id !== data.eventId) {
               return false
            }
            let bets_data = self.state.bets_data
            data.side = data.side === "BACK" ? 0 : 1
            let newDateIndex = bets_data.findIndex((bets, i) => {
               return bets.orderId === msg.payload.orderId
            })
            let newData = [msg.payload]
            if (newDateIndex > -1) {
               newData = bets_data
            }
            else {
               newData = newData.concat(bets_data)
            }
            newData = newData.splice(0, 50)
            // let bets_data_filter_obj = this.state.bets_data_filter_obj
            // for(const itm of res.items){
               // const itm = msg.payload
               const objkey = data.marketBettingType === "LINE" ? "LINE" : data.marketId.toString();
               let curBetObj = this.state[objkey];
               let newDataObj;

               if(!!curBetObj){
                  newDataObj = [data];
                  newDataObj = newDataObj.concat(curBetObj);
                  newDataObj = newDataObj.splice(0, (this.state.betListLimit + 2));
                  // bets_data_filter_obj[objkey] = newDataObj;
               } else {
                  // bets_data_filter_obj[objkey] = [];
                  // bets_data_filter_obj[objkey].push(data);
                  newDataObj = [data];
               }
            // }

            if (this.state.beepAllow && !this.state.isBeepPlaying) {
               // beepaudio.play()
               this.setState({
                  isBeepPlaying: true
               }, () => {
                  try {
                     beep.play()
                  }
                  catch (e) {

                  }
                  // beep.click()
                  // document.getElementById("beepplay").click()
                  // console.log('beep one - ' + (new Date()).toISOString())
               })
               // var playPromise = beep.play();

               // if (playPromise !== undefined) {
               //    playPromise.then(_ => {
               //       // Automatic playback started!
               //       // Show playing UI.
               //       // We can now safely pause video...
               //       //beep.pause();
               //       // beep.
               //       console.log('beep then - ' + (new Date()).toISOString())
               //    })
               //    .catch(error => {
               //       console.log('beep error - ' + (new Date()).toISOString())
               //       console.log(error)
               //       // Auto-play was prevented
               //       // Show paused UI.
               //    });
               // }
            }
            if (!!expos[data.marketId]) {
               expos[data.marketId].runnersExposure = data.runnersExposure
            } else {
               expos[data.marketId] = {}
               expos[data.marketId].marketBettingType = data.marketBettingType
               expos[data.marketId].runnersExposure = data.runnersExposure
            }

            let mktOrderCount = this.state.mktOrderCount
            mktOrderCount[data.marketId] = !!mktOrderCount[data.marketId] ? mktOrderCount[data.marketId] + 1 : 1

            this.setState({ marketExpos: expos, mktOrderCount: mktOrderCount})
            if (data.marketBettingType === "ODDS") {
               self.setState({ bets_data: [], [objkey]: [] }, () => {
                  if (data.marketType === "MATCH_ODDS" || data.marketType === "WINNER" || data.marketType === "TOURNAMENT_WINNER") {
                     self.setState({ bets_data: newData, [objkey]: newDataObj, oddCount: self.state.oddCount + 1, newPopupData: true })
                  } else {
                     self.setState({ bets_data: newData, [objkey]: newDataObj, underOverCount: self.state.underOverCount + 1, newPopupData: true })
                  }
               })
            } else if (data.marketBettingType === "BOOKMAKER") {
               self.setState({ bets_data: [], [objkey]: [] }, () => {
                  self.setState({ bets_data: newData, [objkey]: newDataObj, bmCount: self.state.bmCount + 1, newPopupData: true })
               })
            } else if (data.marketBettingType === "LINE") {
               self.setState({ bets_data: [], [objkey]: [] }, () => {
                  self.setState({ bets_data: newData, [objkey]: newDataObj, fancyCount: self.state.fancyCount + 1, newPopupData: true })
               })
            }
         }
         if (!!msg.command && msg.command === "RESULTDECLARED") {
            self.resultDeclered("market", msg.payload)
            if (msg.payload.pnl > 0) {
               self.props.notify("Congratulations! You WON " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 🤑", "success")
            } else if (msg.payload.pnl < 0) {
               self.props.notify("Oops! You lost " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 😢", "error")
            }
         }
         if (!!msg.command && msg.command === "VOIDORDER") {
           // debugger
            if(!!this.state.lineExpoMktId && this.state.lineExpoMktId === msg.payload.marketId){
               let mktLineExpo = {}
               !!msg.payload.runnersExposure && Array.prototype.forEach.call(Object.keys(msg.payload.runnersExposure),(i) => {
                     mktLineExpo[i] = {}
                     mktLineExpo[i].expo = ((msg.payload.runnersExposure[i].sharingMe))
               })
               this.updateShownExpo(msg.payload.marketId, mktLineExpo)
            }
            self.resultDeclered("order", msg.payload)
            if (msg.payload.pnl > 0) {
               self.props.notify("Your account has been credited with " + msg.payload.pnl + " because of rollback in " + msg.payload.marketName + ".", "success")
            } else if (msg.payload.pnl < 0) {
               self.props.notify("Your account has been debited with " + msg.payload.pnl + " due to rollback in " + msg.payload.marketName + ".", "error")
            }
         }
         if (!!msg.command && msg.command === "RESULTROLLBACK") {
            self.resultDeclered("rollback", msg.payload)
         }
         if (!!msg.command && msg.command === "Orders.NotifyVoidSportsMarket") {
            self.resultDeclered("market", msg.payload)
         }
         if (!!msg.command && msg.command === "SPORTSMARKETVOID") {
            self.resultDeclered("marketvoid", msg.payload)
            self.props.notify(" Market " + msg.payload.marketName + " is Voided !", "error")
         }
         if (!!msg.command && msg.command === "SPORTSAGENTBETPLACED") {
            // debugger
            if(!!this.state.lineExpoMktId && this.state.lineExpoMktId === msg.payload.marketId){
               let mktLineAgentExpo = {}
               !!msg.payload.runnersExposure && Array.prototype.forEach.call(Object.keys(msg.payload.runnersExposure),(i) => {
                  mktLineAgentExpo[i] = {}
                  mktLineAgentExpo[i].expo = ((msg.payload.runnersExposure[i].sharingUP))
               })
               this.updateShownAgentExpo(msg.payload.marketId, mktLineAgentExpo)
            }
            let agentExpos = this.state.marketAgentExpos
            data = JSON.parse(data).payload
            if (self.props.match.params.event_id !== data.eventId) {
               return false
            }
            // let bets_data = self.state.bets_data
            // data.side = data.side === "BACK" ? 0 : 1
            // let newDateIndex = bets_data.findIndex((bets, i) => {
            //    return bets.orderId === msg.payload.orderId
            // })
            // let newData = [msg.payload]
            // if (newDateIndex > -1) {
            //    newData = bets_data
            // }
            // else {
            //    newData = newData.concat(bets_data)
            // }
            // newData = newData.splice(0, 50)
            //    const objkey = data.marketBettingType === "LINE" ? "LINE" : data.marketId.toString();
            //    let curBetObj = this.state[objkey];
            //    let newDataObj;

            //    if(!!curBetObj){
            //       newDataObj = [data];
            //       newDataObj = newDataObj.concat(curBetObj);
            //       newDataObj = newDataObj.splice(0, (this.state.betListLimit + 2));
            //    } else {
            //       newDataObj = [data];
            //    }
            // }

            // if (this.state.beepAllow && !this.state.isBeepPlaying) {
            //    this.setState({
            //       isBeepPlaying: true
            //    }, () => {
            //       try {
            //          beep.play()
            //       }
            //       catch (e) {

            //       }
            //    })
            // }
            if (!!agentExpos[data.marketId]) {
               agentExpos[data.marketId].runnersExposure = data.runnersExposure
            } else {
               agentExpos[data.marketId] = {}
               agentExpos[data.marketId].marketBettingType = data.marketBettingType
               agentExpos[data.marketId].runnersExposure = data.runnersExposure
            }

            // let mktOrderCount = this.state.mktOrderCount
            // mktOrderCount[data.marketId] = !!mktOrderCount[data.marketId] ? mktOrderCount[data.marketId] + 1 : 1

            this.setState({ marketAgentExpos: agentExpos})
            // if (data.marketBettingType === "ODDS") {
            //    self.setState({ bets_data: [], [objkey]: [] }, () => {
            //       if (data.marketType === "MATCH_ODDS" || data.marketType === "WINNER" || data.marketType === "TOURNAMENT_WINNER") {
            //          self.setState({ bets_data: newData, [objkey]: newDataObj, oddCount: self.state.oddCount + 1, newPopupData: true })
            //       } else {
            //          self.setState({ bets_data: newData, [objkey]: newDataObj, underOverCount: self.state.underOverCount + 1, newPopupData: true })
            //       }
            //    })
            // } else if (data.marketBettingType === "BOOKMAKER") {
            //    self.setState({ bets_data: [], [objkey]: [] }, () => {
            //       self.setState({ bets_data: newData, [objkey]: newDataObj, bmCount: self.state.bmCount + 1, newPopupData: true })
            //    })
            // } else if (data.marketBettingType === "LINE") {
            //    self.setState({ bets_data: [], [objkey]: [] }, () => {
            //       self.setState({ bets_data: newData, [objkey]: newDataObj, fancyCount: self.state.fancyCount + 1, newPopupData: true })
            //    })
            // }
         }
         if (!!msg.command && msg.command === "VOIDAGENTORDER") {
            // debugger
            if(!!this.state.lineExpoMktId && this.state.lineExpoMktId === msg.payload.marketId){
               let mktLineAgentExpo = {}
               !!msg.payload.runnersExposure && Array.prototype.forEach.call(Object.keys(msg.payload.runnersExposure),(i) => {
                  mktLineAgentExpo[i] = {}
                  mktLineAgentExpo[i].expo = ((msg.payload.runnersExposure[i].sharingUP))
               })
               this.updateShownAgentExpo(msg.payload.marketId, mktLineAgentExpo)
            }
            // self.resultDeclered("order", msg.payload)
            // if (msg.payload.pnl > 0) {
            //    self.props.notify("Your account has been credited with " + msg.payload.pnl + " because of rollback in " + msg.payload.marketName + ".", "success")
            // } else if (msg.payload.pnl < 0) {
            //    self.props.notify("Your account has been debited with " + msg.payload.pnl + " due to rollback in " + msg.payload.marketName + ".", "error")
            // }

            let agentExpos = this.state.marketAgentExpos
            data = JSON.parse(data).payload
            if (self.props.match.params.event_id !== data.eventId) {
               return false
            }
            if (!!agentExpos[data.marketId]) {
               agentExpos[data.marketId].runnersExposure = data.runnersExposure
            } else {
               agentExpos[data.marketId] = {}
               agentExpos[data.marketId].runnersExposure = data.runnersExposure
            }


            this.setState({ marketAgentExpos: agentExpos})
         }
      })
      socket.on('disconnect', () => {
         socket.emit('user_room', userData.sub);
         socket.emit('site_room', userData.sub);
      })
      dataUpdate = setInterval(async function updatedData() {
         clearInterval(dataUpdate)
         let mBets = []
         eventData = await eventService.getUserEventById(self.props.match.params.event_id)
         if (!eventData.catalogues) {
            dataUpdate = setInterval(updatedData, 5000)
            return false
         }

         if(!!eventData && !!eventData.catalogues && eventData.catalogues.length>0){
            let mktindx = -1;
            for(let i=0;i<eventData.catalogues.length;i++){
               if(!!eventData.catalogues[i] && ((eventData.catalogues[i].bettingType === "ODDS" && eventData.catalogues[i].marketType === "MATCH_ODDS") || (eventData.catalogues[i].bettingType === "BOOKMAKER" && eventData.catalogues[i].marketType === "BOOKMAKER"))){
                  mktindx = i;
                  break;
               }
            }
   
            let forSequenceMkt;
            if(mktindx>-1){
               forSequenceMkt = eventData.catalogues[mktindx];
            }
            
            
            if(!!forSequenceMkt){
               let notLineRunnerIdLst = self.state.notLineRunnerIdList;
               if(notLineRunnerIdLst === {} || Object.keys(notLineRunnerIdLst).length === 0){
                  for(const rnr of forSequenceMkt.runners ){
                     notLineRunnerIdLst[rnr.name] = [];
                  }
               }
               for(const mkkt of eventData.catalogues){
                  if(mkkt.bettingType !==  "LINE" && mkkt.marketType !== "COMPLETED_MATCH" && mkkt.marketType !== "TIED_MATCH" && mkkt.marketType !== "OVER_UNDER_35" && mkkt.marketType !== "OVER_UNDER_25" && mkkt.marketType !== "OVER_UNDER_15" && mkkt.marketType !== "OVER_UNDER_05" && mkkt.marketType !== "TO_WIN_THE_TOSS"){
                     for(const rnrr of mkkt.runners ){
                        if(!!notLineRunnerIdLst[rnrr.name.toString().trim()] && !notLineRunnerIdLst[rnrr.name.toString().trim()].includes(rnrr.id)){
                           notLineRunnerIdLst[rnrr.name.toString().trim()].push(rnrr.id);
                        }
                     }     
                  }
               }
               self.setState({notLineRunnerIdList: notLineRunnerIdLst});
            }
         }

         let msgs = !!eventData.metadata && !!eventData.metadata.messages ? JSON.parse(eventData.metadata.messages) : {}
         let inActiveMkts = !!eventData.metadata && !!eventData.metadata.inactiveMarkets ? JSON.parse(eventData.metadata.inactiveMarkets) : []

         self.setState({ marketMsg: msgs })

         eventData.catalogues = eventData.catalogues.filter((mkt) => {
            return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
         })
         // self.calculateCount(expos)
         // let expos = await marketService.getEventResults(self.props.match.params.event_id)
         !!eventData.catalogues && Array.prototype.forEach.call(eventData.catalogues, (market, i) => {
            // let mkt_exposour = !!expos && expos.filter((exp) => {
            //    return exp.marketId === market.marketId
            // })
            // eventData.catalogues[i].expo = mkt_exposour.length > 0 ? mkt_exposour[0] : {}
            if (!!eventData.metadata && !!eventData.metadata.books) {
               // let mktBook = stringParser.deSrlz("book|" + eventData.metadata.books[market.marketId])
               let mktBookData = JSON.parse(eventData.metadata.books)
               let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : {}
               eventData.catalogues[i].metadata = {}
               eventData.catalogues[i].metadata.book = mktBook
            } else {
               let baseData = {
                  marketId: market.marketId,
                  status: "OPEN",
                  runners: []
               }
               Array.prototype.forEach.call(eventData.catalogues[i].runners, (rnr) => {
                  let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                  baseData.runners.push(data)
               })
               eventData.catalogues[i].metadata = {}
               eventData.catalogues[i].metadata.book = baseData
            }
         })
         var moPos = !!eventData.catalogues && eventData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
         if (!!eventData && eventData.catalogues && moPos !== -1) {
            let mom = [eventData.catalogues[moPos]]
            eventData.catalogues.splice(moPos, 1)
            eventData.catalogues = mom.concat(eventData.catalogues)
         }
         let fancy_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
         })
         let line_mkts = []
         // let line_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
         //    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && mkt.provider === "BETFAIR" && mkt.bettingType === "LINE" && !!mkt.metadata && !!mkt.metadata.books && !!mkt.metadata.book.marketId
         // })
         let odds_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE") && !!mkt.metadata && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
         })
         fancy_mkts = fancy_mkts.length > 0 ? fancy_mkts.sort((a, b) => a.marketId - b.marketId) : [];

         let mktOrderCount = self.state.mktOrderCount
         // console.log(eventData)
         Array.prototype.forEach.call(eventData.catalogues,(mkt) => {
            if (!mktOrderCount[mkt.marketId]){
               mktOrderCount[mkt.marketId] = 0
            }
         })
         // self.setState({ eventData: {}, lineMarkets: [], fancyMarkets: [], oddsMarkets: [] }, () => {
         self.setState({ eventData: {}, oddsMarkets: [], isEventUpdate: true, mktOrderCount: mktOrderCount }, () => {
            self.setState({ eventData: eventData, lineMarkets: line_mkts, fancyMarkets: fancy_mkts, oddsMarkets: odds_mkts, matched_bet: mBets, matched_bet_filter: mBets }, () => {
               self.setState({ isEventUpdate: false })
            })
            dataUpdate = setInterval(updatedData, 15000)
         })
      }
         , 15000)
      window.addEventListener("scroll", () => {
         let headerHeight = document.getElementById("menu").offsetHeight
         let betSLipMenuOffset = window.pageYOffset
         if (betSLipMenuOffset > headerHeight) {
            document.getElementById("main-analysis-st").style.top = headerHeight.toString() + "px"
            document.getElementById("main-analysis-st").classList.add("sticky");
         } else {
            document.getElementById("main-analysis-st").style.removeProperty("top")
            document.getElementById("main-analysis-st").classList.remove("sticky");
         }
      })
   }

   componentDidUpdate() {
      // componentWillReceiveProps(){
      const self = this;
      setTimeout(() => {
          if (!!self.state.eventData && !!self.state.eventData.event && self.state.eventData.event.id !== self.props.match.params.event_id) {
              clearInterval(dataUpdate)
              self.setState({
               uid: "",
               passcode: "",
               showPopupBets: false,
               showPopupUserBook: false,
               showPopupBetsLock: false,
               showPopupFancyBook: false,
               showBetsLockMenu: false,
               showFancyLockMenu: false,
               showMarketBetDetail: false,
               showUserDetailPopup: false,
               betsClientsIP: "",
               betsAmountFrom: "",
               betsAmountTo: "",
               userBetDelay: "",
               masterPassword: "",
               userBetLock: false,
               marketBetDetail: [],
               marketuserDetail: [],
               userDetail: [],
               usermktData: {},
               eventData: {},
               fancyMarkets: [],
               lineMarkets: [],
               oddsMarkets: [],
               matched_bet: [],
               matched_bet_filter: [],
               showExpo: false,
               lineExpoMktId: null,
               lineExpo: {},
               lineName:"",
               tvUrl: "",
               streamName: "",
               tvIP: "",
               toastMsg: "",
               toastType: "",
               showToast: false,
               bets_data: [],
               accounts: "",
               frontData: {},
               betListLimit: 20,
               betFilter: "",
               mktFeedBooks: {},
               openUserBook: false,
               openAgentCuttingModal: false,
               bookMkt: {},
               oddCount: 0,
               bmCount: 0,
               fancyCount: 0,
               mktOrderCount: {},
               underOverCount: 0,
               newPopupData: false,
               deactivatMarkets: [],
               deactivatOrders: [],
               eventDetail: {},
               tvShow: false,
               fancyFilter: "all",
               showFancy: true,
               hideMkt: [],
               beepAllow: false,
               isBeepPlaying: false,
               avgBookPopup: false,
               avgMarket: {},
               avgCurrRunnerId: "",
               marketExpos: {},
               showMarketBetLock: false,
               marketMsg: {},
               betLockMkt: {},
               isGraphicScore: false,
               subscribedMarkets: [],
               scoreUrl: "",
               expoPrice: null,
               isEventUpdate: false,
               isVisible: true,
               updateProps: false,
               consoleRights: false,
               onShowPnLReportMarketPopup:false,
               pnLReportMarkets: null,
               sportAnalysisEventDetails: null
            }, () => {
                  self.componentDidMount();
              })
          }
      }, 100);
  }
   calculateCount(expos) {
      let oddCount = 0
      let bmCount = 0
      let fancyCount = 0
      let underOverCount = 0
      let mktOrderCount = this.state.mktOrderCount
      !!expos && Array.prototype.forEach.call(expos, (mkt) => {
         if (mkt.marketBettingType === "ODDS") {
            if (mkt.marketType === "MATCH_ODDS" || mkt.marketType === "WINNER" || mkt.marketType === "TOURNAMENT_WINNER") {
               oddCount = oddCount + mkt.orderCount
            } else {
               underOverCount = underOverCount + mkt.orderCount
            }
         } else if (mkt.marketBettingType === "BOOKMAKER") {
            bmCount = bmCount + mkt.orderCount
         } else if (mkt.marketBettingType === "LINE") {
            fancyCount = fancyCount + mkt.orderCount
         }
         mktOrderCount[mkt.marketId] = mkt.orderCount
      })
      this.setState({ oddCount: oddCount, bmCount: bmCount, fancyCount: fancyCount, underOverCount: underOverCount, mktOrderCount: mktOrderCount })
   }
   async onSubmitForm() {
      // let body = {
      //    "filters": {
      //       "BetStatuses": ["PLACED", "REQUESTED", "REJECTED"],
      //       "current_user": this.state.accounts,
      //       "user_id": "",
      //       "amount_from": 0.0,
      //       "amount_to": 0.0,
      //       "market_id": "",
      //       "event_id": this.props.match.params.event_id,
      //       "competition_id": "",
      //       "sport_type": "",
      //       "market_type": "",
      //    },
      //    "last_id": "",
      //    "first_id": "",
      //    "action": "",
      //    "from": "",
      //    "to": "",
      //    "page_no": 1,
      //    "count_records": 0,
      //    "records_display": this.state.betListLimit
      // }
      let body = {
         "filters":{
             "userId": "",
             "betStatus": ["PLACED", "REQUESTED", "REJECTED"],
             "marketId": "",
             "eventId": this.props.match.params.event_id,
             "competitionId": "",
             "sportType": "",
             "marketType": "",
             "amountFrom": 0.0,
             "amountTo": 0.0
         },
         "lastId": "",
         "firstId": "",
         "action": "",
         "from": "",
         "to": "",
         "countRecords": "",
         "pageNo": 0,
         "recordsPerPage": this.state.betListLimit
     
     }
      body = this.clean(body);
      const self = this;
      await currentBetsService.postApiOpenBets(body).then((res) => {
         if (res.isSuccess) {
           // debugger
            let bets_data_filter_obj = {}//this.state.bets_data_filter_obj
            for(const itm of res.items){
               const objkey = itm.marketBettingType === "LINE" ? "LINE" : itm.marketId.toString();
               let curBetObj = bets_data_filter_obj[objkey];
               if(!!curBetObj){
                  bets_data_filter_obj[objkey].push(itm);
               } else {
                  bets_data_filter_obj[objkey] = [];
                  bets_data_filter_obj[objkey].push(itm);
               }
            }
            bets_data_filter_obj.bets_data = res.items
            self.setState(
               {
                  bets_data: [],
               }, () => {
                  // self.setState({ bets_data: res.items })
                  self.setState(bets_data_filter_obj)
               }
            );
         }
         else {
            // this.setState({ bets_data: [] })
         }
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   openUserBooks(mkt) {
      this.setState({ bookMkt: mkt, openUserBook: true })
   }
   closeUserBook() {
      this.setState({ bookMkt: "", openUserBook: false })
   }
   openAgentCuttingModal(mkt) {
      mkt.competition = this.state.eventDetail.competition;
      mkt.event = this.state.eventDetail.event;
      this.setState({ agentCuttingMkt: mkt, openAgentCuttingModal: true })
   }
   closeAgentCuttingModal() {
      this.setState({ agentCuttingMkt: "", openAgentCuttingModal: false })
   }
   showMarketBetLock(mkt) {
      this.setState({ betLockMkt: mkt, showMarketBetLock: true })
   }
   closeMarketBetLock() {
      this.setState({ showMarketBetLock: false, betLockMkt: {} })
   }
   showAvgBookPopup(mkt, currRunnerId) {
      this.setState({ avgBookPopup: true, avgMarket: mkt, avgCurrRunnerId: currRunnerId })
   }
   hideAvgBookPopup() {
      this.setState({ avgBookPopup: false, avgMarket: {} })
   }
   newPopupData() {
      this.setState({ newPopupData: false })
   }
   hideUserDetailPopup() {
      this.setState({ showUserDetailPopup: false, userBetDelay: "", userBetLock: false })
   }
   async showUserDetailPopup(bet) {
      let userData = await apiUserService.getDashboard(bet.username)
      let usermktData = await userService.getUserMarketExposure(bet.username, bet.marketId);
      usermktData = usermktData.items
      this.setState({ userDetail: [], marketuserDetail: [], usermktData: {}, userBetDelay: "", userBetLock: false }, () => {
         this.setState({
            userDetail: bet,
            marketuserDetail: userData,
            userBetDelay: userData.betDelay,
            userBetLock: userData.betLock,
            usermktData: usermktData[0],
            showUserDetailPopup: true
         })
      })
   }
   hidePopupBets() {
      this.setState({ showPopupBets: false, })
   }
   showPopupBets() {
      this.setState({ showPopupBets: true, })
   }
   hideMarketBetDetail() {
      this.setState({ showMarketBetDetail: false })
   }
   showMarketBetDetail(bet) {
      this.setState({ showMarketBetDetail: true, marketBetDetail: [] }, () => { this.setState({ marketBetDetail: bet }) })
   }
   hidePopupUserBook() {
      this.setState({ showPopupUserBook: false, })
   }
   showPopupUserBook() {
      this.setState({ showPopupUserBook: true, })
   }
   hidePopupBetsLock() {
      this.setState({ showPopupBetsLock: false, })
   }
   showPopupBetsLock() {
      this.setState({ showPopupBetsLock: true, })
   }
   hidePopupFancyBook() {
      this.setState({ showPopupFancyBook: false, })
   }
   showPopupFancyBook() {
      this.setState({ showPopupFancyBook: true, })
   }
   hideBetsLockMenu() {
      this.setState({ showBetsLockMenu: false, })
   }
   showBetsLockMenu() {
      this.setState({ showBetsLockMenu: true, })
   }
   hideFancyLockMenu() {
      this.setState({ showFancyLockMenu: false, })
   }
   showFancyLockMenu() {
      this.setState({ showFancyLockMenu: true, })
   }

   updateShownExpo(linExpoMktId, data){
      if(this.state.showExpo && this.state.lineExpoMktId === linExpoMktId){
         this.setState({ lineExpo: data })
      }
   }
   updateShownAgentExpo(linExpoMktId, agentData){
      if(this.state.showExpo && this.state.lineExpoMktId === linExpoMktId){
         this.setState({ lineAgentExpo: agentData })
      }
   }
   showExpo(linExpoMktId, data, agentData, price, lineName) {
      this.setState({ showExpo: true, lineExpoMktId: linExpoMktId, lineExpo: data, lineAgentExpo: agentData, lineName:lineName, expoPrice: price })
   }
   hideExpo() {
      this.setState({ showExpo: false, lineExpoMktId:null, lineExpo: {}, lineAgentExpo:{}, lineName: "" })
   }
   betsSearch() {
      let mbt = this.state.matched_bet
      let amountFrom = parseFloat(this.state.betsAmountFrom)
      let amountTo = parseFloat(this.state.betsAmountTo)
      let clientIP = this.state.betsClientsIP
      if (!!amountFrom && !!amountTo) {
         if (amountTo < amountFrom) {
            amountFrom = this.state.betsAmountTo
            amountTo = this.state.betsAmountFrom
         }
         mbt = mbt.filter(m => { return m.amount >= amountFrom && m.amount <= amountTo })
      }
      else if (!!amountFrom) {
         mbt = mbt.filter(m => { return m.amount >= amountFrom })
      }
      else if (!!amountTo) {
         mbt = mbt.filter(m => { return m.amount <= amountTo })
      }

      if (clientIP !== "") {
         mbt = mbt.filter(m => { return m.clientIP === clientIP })
      }
      this.setState({ matched_bet_filter: mbt })
   }
   betsViewAll() {
      this.setState({ matched_bet_filter: this.state.matched_bet, betsAmountTo: "", betsAmountFrom: "", betsClientsIP: "" })
   }
   async onUserBetLock(user) {
      if (!this.state.masterPassword) {
         this.props.notify("Please insert master password!", "error");
         return false
      }
      let body = {
         "username": user,
         "password": this.state.masterPassword
      }
      if (this.state.userBetLock) {
         await userService.blockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      } else {
         await userService.unBlockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      }
      this.setState({ masterPassword: "" })
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onCheckChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   applyFilter(market) {
     // debugger
      this.setState({ betFilter: market })
   }
   updateBook(marketId, book) {
      let feedBooks = this.state.mktFeedBooks
      feedBooks[marketId] = book
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.mktFeedBooks = feedBooks
   }

   filteredBets() {
      let btFilter = this.state.betFilter
      let bets = btFilter === "" ? this.state.bets_data : !!this.state[btFilter] ? this.state[btFilter] : this.state.bets_data
      bets = bets.filter((bet) => {
         return this.state.deactivatMarkets.indexOf(bet.marketId) === -1
      })
      bets = bets.filter((bet) => {
         return this.state.deactivatOrders.indexOf(bet.orderId) === -1
      })
      // if (btFilter === "") {
      //    return bets
      // } else if (btFilter === "LINE") {
      //    return bets.filter((bt, i) => {
      //       return bt.marketBettingType === "LINE"
      //    })
      // } else {
      //    return bets.filter((bt, i) => {
      //       return bt.marketId === btFilter
      //    })
      // }
      return bets
   }
   arrayGroupByBKP(ary, attr) {
      let group = ary.reduce((r, a) => {
         r[a[attr]] = [...r[a[attr]] || [], a];
         return r;
      }, {});
      return group
   }
   arrayGroupBy(ary, attr) {
      // debugger
      let group = ary.reduce((r, a) => {
          if(a['bettingType'] === 'LINE' && a['provider'] === 'BETFAIR' && ((a[attr].indexOf('1_INNING') === 0 || a[attr].indexOf('2_INNING') === 0) && a[attr].indexOf('_OVR_LINE') > 7)){
              const attrinnings = a[attr].indexOf('1_INNING') === 0 ? '1ST_INNINGS_RUNS' : '2ND_INNINGS_RUNS';
              r[attrinnings] = [...r[attrinnings] || [], a];
          }else{
              r[a[attr]] = [...r[a[attr]] || [], a];
          }
          return r;
      }, {});
      return group
   }
   
   orgenizedFancy(markets) {
      if (!markets) {
         return {}
      }
      let newObj = {}

      if (!!markets["THREE_SELECTIONS"]) {
         newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"]
         delete markets["THREE_SELECTIONS"]
      }
      if (!!markets["1ST_INNINGS_RUNS"]) {
         newObj["1ST_INNINGS_RUNS"] = markets["1ST_INNINGS_RUNS"]
         delete markets["1ST_INNINGS_RUNS"]
      }
      if (!!markets["2ND_INNINGS_RUNS"]) {
         newObj["2ND_INNINGS_RUNS"] = markets["2ND_INNINGS_RUNS"]
         delete markets["2ND_INNINGS_RUNS"]
      }
      if (!!markets["OVERS"]) {
         newObj["OVERS"] = markets["OVERS"]
         delete markets["OVERS"]
      }
      if (!!markets["SINGLE_OVER"]) {
         newObj["SINGLE_OVER"] = markets["SINGLE_OVER"]
         delete markets["SINGLE_OVER"]
      }
      if (!!markets["BATSMAN"]) {
         newObj["BATSMAN"] = markets["BATSMAN"]
         delete markets["BATSMAN"]
      }
      if (!!markets["BALL_BY_BALL"]) {
         newObj["BALL_BY_BALL"] = markets["BALL_BY_BALL"]
         delete markets["BALL_BY_BALL"]
      }
      if (!!markets["ODD_EVEN"]) {
         newObj["ODD_EVEN"] = markets["ODD_EVEN"]
         delete markets["ODD_EVEN"]
      }
      if (!!markets["OTHERS"]) {
         newObj["OTHERS"] = markets["OTHERS"]
         delete markets["OTHERS"]
      }
      newObj = { ...newObj, ...markets }
      let fancys = []
      Array.prototype.forEach.call(Object.keys(newObj), (type) => {
         newObj[type] = newObj[type].sort((a, b) => {
            return a.sortPriority - b.sortPriority;
        });
         fancys = fancys.concat(newObj[type])
      })
      return fancys
   }
   applyFancyFilter(flt) {
      this.setState({ fancyFilter: "" }, () => {
         this.setState({ fancyFilter: flt })
      })
   }
   fancyFilterApplyBKP(mktList) {
      let filter = this.state.fancyFilter
      if (filter !== "all") {
         mktList = mktList.filter((mkt, i) => {
            return mkt.marketType === filter
         })
      }
      return mktList
   }
   fancyFilterApply(mktList) {
      let filter = this.state.fancyFilter
      if (filter !== "all") {
          mktList = mktList.filter((mkt, i) => {
              if(filter === "1ST_INNINGS_RUNS"){
                  return ((mkt.marketType.indexOf('1_INNING') === 0 && mkt.marketType.indexOf('_OVR_LINE') > 7) || mkt.marketType === filter)
              } else if (filter === "2ND_INNINGS_RUNS"){
                  return ((mkt.marketType.indexOf('2_INNING') === 0 && mkt.marketType.indexOf('_OVR_LINE') > 7) || mkt.marketType === filter)
              } else {
                  return  mkt.marketType === filter
              }
          })
      }
      return mktList
  }
   toggleOpenMkt(mktId) {
      let hideMkt = this.state.hideMkt
      let mktIndex = hideMkt.indexOf(mktId)
      if (mktIndex === -1) {
         hideMkt.push(mktId)
      } else {
         hideMkt.splice(mktIndex, 1)
      }
      this.setState({ hideMkt: hideMkt })
   }

   updateSubscribedMarkets(mkt) {
      let mktList = this.state.subscribedMarkets
      mktList.push(mkt)
      this.setState({ subscribedMarkets: mktList })
   }
   componentWillUnmount() {
      beep.removeEventListener('ended', null)
      window.removeEventListener('scroll', null)
      document.removeEventListener("visibilitychange", null)
      clearInterval(dataUpdate)
   }

   beepAudioClick() {
      beep.play();
   }
   sortGameCatalogues(catArray) {
      let mktArray = catArray
      mktArray = mktArray.sort((a, b) => a.sortPriority - b.sortPriority);
      return mktArray;
   }

   text(url) {
       return fetch(url).then(res => res.text());
   }
   async getMyIp() {
       let ip = ""
       await this.text('https://www.cloudflare.com/cdn-cgi/trace').then(data => {
           data = data.split("\n")
           data.forEach((str) => {
               if (str.includes("ip=")) {
                   ip = str.split("ip=")[1]
               }
           })
       });
       return ip
   }

   async liveTvToggle() {
      const self = this
      if (!this.state.tvShow && this.state.tvIP === "" && (this.state.eventDetail.eventType.id === "1" || this.state.eventDetail.eventType.id === "2" || this.state.eventDetail.eventType.id === "7") && this.state.tvUrl.includes("ip=")) {
         let client_ip = await this.getMyIp()
         let tvUrl = self.state.tvUrl + client_ip
         self.setState({ tvShow: !self.state.tvShow, tvUrl: tvUrl, tvIP: client_ip })
         // utilService.getClientIPOwnApi().then((res) => {
         //    if (!!res && !!res.ip) {
         //       let tvUrl = self.state.tvUrl + res.ip
         //       self.setState({ tvShow: !self.state.tvShow, tvUrl: tvUrl, tvIP: res.ip })
         //    }
         //    else {
         //       self.setState({ tvShow: !self.state.tvShow })
         //    }
         // }).catch(error => {
         //    self.setState({ tvShow: !self.state.tvShow })
         // });
      } else {
         if (!this.state.tvShow && this.state.tvUrl.includes(NANO_TV_URL)) {
            providerIframeService.tvNanoTempToken({ url: this.state.tvUrl }).then((res) => {
               this.setState({ streamName: res.url, tvShow: !this.state.tvShow })
            })
         }
         else if (!this.state.tvShow && this.state.tvUrl.includes(FLASH_TV_URL)) {
            providerIframeService.tvFlashTempToken({ url: this.state.tvUrl }).then((res) => {
               this.setState({ streamName: res.url, tvShow: !this.state.tvShow })
            })
         }
         else {
            this.setState({ tvShow: !this.state.tvShow })
         }
      }
   }

   onShowPnLReportMarketPopup(){
      const self = this;
      const body = {
         "userId": "",
         "eventId": this.state.eventData.event.id
      }
      eventPnLReportService.postSettledMarketPnl(body).then((res) => {
         if (res.isSuccess) {
               let eventObj = {};
               eventObj['eventId'] = self.state.eventData.event.id;
               eventObj['eventName'] = self.state.eventData.event.name;
               eventObj['compId'] = self.state.eventData.competition.id;
               eventObj['compName'] = self.state.eventData.competition.name;
               let totalOrderCnt = 0
               let totalPnL = 0
               let totalStakes = 0
               let res_items = res.items.filter(m => { return m.eventTypeId !== '99' && m.eventTypeId !== '999' });
               res_items.sort((a, b) => new Date(b.resultDetail[0].actionTime).getTime() - new Date(a.resultDetail[0].actionTime).getTime())
               for (const resitm of res_items){
                  totalOrderCnt += resitm.orderCount;
                  totalPnL += resitm.pnl;
                  totalStakes += resitm.totalAmount;
               }
               self.setState({
                  onShowPnLReportMarketPopup: true,
                  pnLReportMarkets: {marketList: res_items, totalPnL: totalPnL, totalStakes: totalStakes, totalOrderCnt: totalOrderCnt},
                  sportAnalysisEventDetails: eventObj
               });
         } else {
            this.setState({ eventPnL_data: [], showData: true, loader: false })
         }
      })

      
   }
   onHidePnLReportMarketPopup(){
      const self = this;
      self.setState({
         onShowPnLReportMarketPopup: false,
         pnLReportMarkets: null,
         sportAnalysisEventDetails: null
      })
   }

   toggleComboBookOpen(){
      this.setState({isComboBookOpen:!this.state.isComboBookOpen});
   }

   cricketScore() {
       if (!!localStorage.getItem("userAuthDetail")) {
           let body = {
               eventId: this.props.match.params.event_id,
               token: JSON.parse(localStorage.getItem("userAuthDetail")).token,
               runners: this.state.runners,
               score: this.state.frontData,
               waterMark:  document.title.split("|")[0].trim(),
               message: {logoUrl: `${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`},
           }

            providerIframeService.cricketScoreTempToken(body).then((res) => {
               this.setState({ cricketScoreUrl: res.url },
                  ()=>{
                     document.getElementById("cricket_score_iframe").style.height = "0px"
                  }
               )
               window.addEventListener('message', function(event) {
                   if(event.origin === res.url.split("?")[0]){
                       document.getElementById("cricket_score_iframe").style.height = event.data+"px"
                   }
               });
           })
       }
   }

   lmtScore() {
       if (!!this.state.score_id) {
           let body = {
               eventId: this.props.match.params.event_id,
               scoreId: this.state.score_id,
               style: this.state.lmtTheme,
               logoUrl: `${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`
           }

            providerIframeService.lmtScoreTempToken(body).then((res) => {
               this.setState({ lmtScoreUrl: res.url },
                  ()=>{
                     document.getElementById("soccer_tennis_score_iframe").style.height = "0px"
                  }
               )
               window.addEventListener('message', function(event) {
                  if(event.origin === res.url.split("?")[0]){
                     document.getElementById("soccer_tennis_score_iframe").style.height = event.data+"px"
                  }
               });
           })
       }
   }

   render() {
      let betList = this.filteredBets()
      let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType")
      fancyMarkets = this.orgenizedFancy(fancyMarkets)
      let fmkt = this.arrayGroupBy(fancyMarkets, "marketType")
      let maketTypeList = Object.keys(fmkt).map((fnc, i) => { return fnc = { mkt: fnc, count: fmkt[fnc].length } })
      fancyMarkets = this.fancyFilterApply(fancyMarkets)
      let oddsMarkets = !!this.state.oddsMarkets ? this.sortGameCatalogues(this.state.oddsMarkets) : []
      const comboBookAllowedEventId = ['1','2','4','400'];
      // let maketTypeList = Object.keys(fancyMarkets).map((fnc, i) => { return fnc = { mkt: fnc, count: fancyMarkets[fnc].length } })
      // fancyMarkets = this.orgenizedFancy(fancyMarkets)
      // fancyMarkets = this.fancyFilterApply(fancyMarkets)
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box mainbox-mobile">
                           <div className="row analysis-running-market mt-1">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-7">
                                 <div className="in-play-left pb-0 mb-0 p-0">
                                    <div className="main-in-play">
                                       {!!this.state.eventDetail.eventType && (["1", "2", "4", "400", "500"].includes(this.state.eventDetail.eventType.id)) &&
                                          <div className="top grd-background toppadding">
                                             <h4 className="w-100">
                                                <span>{!!this.state.eventDetail.event && !!this.state.eventDetail.event["name"] ? this.state.eventDetail.event["name"] : null} - {!!this.state.eventDetail.competition && !!this.state.eventDetail.competition["name"] ? this.state.eventDetail.competition["name"] : null}</span>
                                                <span className="float-right">{!!this.state.eventDetail.event ? scoreFormatDate(this.state.eventDetail.event["openDate"]) : ""}</span>
                                                {this.state.beepAllow ? <span className="ml-2" onClick={() => { this.setState({ beepAllow: !this.state.beepAllow }) }}><i className="fa fa-volume-up" aria-hidden="true"></i></span> :
                                                   <span className="ml-2" onClick={() => { this.setState({ beepAllow: !this.state.beepAllow }) }}><i className="fa fa-volume-off" aria-hidden="true"></i></span>}
                                             </h4>
                                          </div>
                                       }
                                       <div className="livetv mt-1" style={{ marginBottom: "-11px" }}>
                                          {!!this.state.tvUrl && this.state.tvUrl !== "" && <>
                                             <div className="center-box libtnonoff" >
                                                <p style={{ width: "100%", maxWidth: "100%" }}>
                                                      <span style={{ padding: "5px 0px 0px 5px", display: "inline-block" }}>Live TV</span>
                                                      <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.liveTvToggle() }} >
                                                         <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                                         <label className="custom-control-label" for="customSwitches" ></label>
                                                      </div>
                                                </p>
                                             </div>
                                             {!!this.state.tvShow && !this.state.isDesktop && <div className="mb-0 tviframe mobiletviframe" style={{ marginTop: "-8px", marginBottom: "-4px" }} > <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} marginwidth='0' marginheight='0' frameborder='0' width='100%' height='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe></div>}
                                          </>}
                                       </div>
                                       {!SHOW_CRICKET_SCORE_IFRAME && !!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "4" && <ScoreBoard socket={socket} beepAllow={this.state.beepAllow} toggleBeep={() => { this.setState({ beepAllow: !this.state.beepAllow }) }} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} frontData={this.state.frontData} event_id={this.props.match.params.event_id} />}
                                       {/* {!!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "1" && <SoccerBoard beepAllow={this.state.beepAllow} toggleBeep={() => { this.setState({ beepAllow: !this.state.beepAllow }) }} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} game={this.state.eventDetail} frontData={this.state.frontData} event_id={this.props.match.params.event_id} />} */}
                                       {/* {!!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "2" && <TennisBoard beepAllow={this.state.beepAllow} toggleBeep={() => { this.setState({ beepAllow: !this.state.beepAllow }) }} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} game={this.state.eventDetail} frontData={this.state.frontData} event_id={this.props.match.params.event_id} />} */}
                                       {/* {!!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "400" && <KabaddiBoard beepAllow={this.state.beepAllow} toggleBeep={() => { this.setState({ beepAllow: !this.state.beepAllow }) }} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} game={this.state.eventDetail} frontData={this.state.frontData} event_id={this.props.match.params.event_id} />}
                                       {!!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "500" && <ElectionBoard beepAllow={this.state.beepAllow} toggleBeep={() => { this.setState({ beepAllow: !this.state.beepAllow }) }} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} game={this.state.eventDetail} frontData={this.state.frontData} event_id={this.props.match.params.event_id} />} */}
                                       {!!this.state.eventDetail.eventType && (this.state.eventDetail.eventType.id === "7" || this.state.eventDetail.eventType.id === "4339") &&
                                          <React.Fragment>
                                             {/* <div className='racetitle'>
                                                <span>{!!this.state.eventData.event && !!this.state.eventData.event["countryCode"] ? this.state.eventData.event["countryCode"] : null}</span> 
                                                <span className="float-right"></span> 
                                             </div> */}
                                             <div className="top grd-background toppadding">
                                                <h4 className="w-100">
                                                   <span>{!!this.state.eventData.event && !!this.state.eventData.event["countryCode"] ? this.state.eventData.event["countryCode"] : null}</span>
                                                   <span className="float-right"></span>
                                                </h4>
                                             </div>
                                             <div class="top subtitle sub_path center-box crname ">
                                                <p class="horsetitlebg" style={{ marginBottom: '0', padding: '5px 10px 5px 7px' }}>
                                                   <span className=''>{!!this.state.eventData.event && !!this.state.eventData.event["venue"] ? this.state.eventData.event["venue"] : null}</span>
                                                   <span className="f-right">{!!this.state.eventData.event ? moment(this.state.eventData.event["openDate"]).format("MMM DD, YYYY - HH:mm") : ""}</span></p>
                                             </div>
                                          </React.Fragment>
                                       }
                                       {SHOW_CRICKET_SCORE_IFRAME && !!this.state.eventDetail.eventType && this.state.eventDetail.eventType.id === "4" && !!this.state.cricketScoreUrl && <>
                                          <div className='iframescoreboard-cricket'>
                                             <iframe title={"Score"} key={"iframe_mob_cri"} id='cricket_score_iframe' src={!!this.state.cricketScoreUrl ? this.state.cricketScoreUrl : ""} marginwidth='0' marginheight='0' frameborder='0' width='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe>
                                          </div>
                                       </>}
                                       {SHOW_LMT_IFRAME && !!this.state.eventDetail.eventType && (this.state.eventDetail.eventType.id === "1" || this.state.eventDetail.eventType.id === "2") && !!this.state.lmtScoreUrl &&
                                          <div>
                                                {/* Do not remove below 7 lines without Jigar Sheth Permission */}
                                                {/* <div className="">
                                                   Change Theme
                                                   <button type="button" class="btn btn-danger btn-circle ml-3" onClick={()=>{this.setState({lmtTheme: "white-red-theme"},()=>{this.lmtScore()})}}></button>
                                                   <button type="button" class="btn btn-primary btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "blue-theme"},()=>{this.lmtScore()})}}></button>
                                                   <button type="button" class="btn btn-warning btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "white-yellow-theme"},()=>{this.lmtScore()})}}></button>
                                                   <button type="button" class="btn btn-dark btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "black-theme"},()=>{this.lmtScore()})}}></button>
                                                </div> */}
                                                <iframe title={"Score"} key={"iframe_mob_soc"} id='soccer_tennis_score_iframe' src={!!this.state.lmtScoreUrl ? this.state.lmtScoreUrl : ""} marginwidth='0' marginheight='0' frameborder='0' width='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe>
                                          </div>
                                       }
                                       {!SHOW_LMT_IFRAME && (!!this.state.eventDetail.eventType && (this.state.eventDetail.eventType.id === "1" || this.state.eventDetail.eventType.id === "2")) && <>
                                          <div style={{ margin: "0px -8px" }}>
                                             {this.state.eventDetail.eventType.id === "1" ? <GraphicScore eventType={"footballlive"} event_id={this.props.match.params.event_id} score_id={this.state.score_id} />
                                                : this.state.eventDetail.eventType.id === "2" ? <GraphicScore eventType={"tenniscourtview"} event_id={this.props.match.params.event_id} score_id={this.state.score_id} />
                                                   : null
                                             }
                                          </div>
                                       </>
                                       }

                                    </div>
                                 </div>
                                 {
                                    comboBookAllowedEventId.includes(!!this.state.eventData && !!this.state.eventData.eventType && !!this.state.eventData.eventType.id?this.state.eventData.eventType.id:"")  &&
                                    <>
                                       <ComboBook mktExpos={this.state.marketExpos} mktAgentExpos={this.state.marketAgentExpos} notLineRunnerIdList={this.state.notLineRunnerIdList} isComboBookOpen={this.state.isComboBookOpen} toggleComboBookOpen={()=> this.toggleComboBookOpen()}/>
                                    </>
                                 }
                                 {!!this.state.oddsMarkets && oddsMarkets.map((mkt, i) => {
                                    if (mkt.marketType === "TIED_MATCH" || mkt.marketType === "COMPLETED_MATCH" || mkt.marketType === "WINNING_ODDS") {
                                       return false
                                    }
                                    let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                    return (
                                       <>
                                          <WebMarket key={mkt.marketId} consoleRights={this.state.consoleRights} eventType={this.state.eventData.eventType.id} isVisible={this.state.isVisible} updateProps={this.state.updateProps} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mktt) => { this.updateSubscribedMarkets(mktt) }} mktExpos={this.state.marketExpos} mktAgentExpos={this.state.marketAgentExpos} feedBooks={this.state.mktFeedBooks} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} showAvgBookPopup={(mkt, currRunnerId) => { this.showAvgBookPopup(mkt, currRunnerId) }} showMarketBetLock={(mkt) => { this.showMarketBetLock(mkt) }} openUserBooks={(mktId) => { this.openUserBooks(mkt) }} openAgentCuttingModal={(mktId) => { this.openAgentCuttingModal(mkt) }} applyFilter={() => { this.applyFilter(mkt.marketId) }} betFilter={this.state.betFilter} socket={socket} market={mkt} curBets={this.state.matched_bet} orderCount={!!this.state.mktOrderCount[mkt.marketId] ? this.state.mktOrderCount[mkt.marketId] : 0} />
                                       </>)
                                 })}
                                 {!!fancyMarkets && fancyMarkets.length > 0 && <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="main-analysis mb-2">
                                          <div className="fancybtn-new">
                                             <a style={this.state.betFilter === "LINE" ? { cursor: "pointer", color: "black" } : { cursor: "pointer" }} onClick={() => { this.applyFilter("LINE") }}>Fancy {this.state.showFancy ? <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-minus fancyplusminusmob pl-4 " aria-hidden="true"></i> : <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-plus fancyplusminusmob pl-4" aria-hidden="true"></i>}</a>
                                          </div>
                                          <div className="w-100 d-block fancybg">
                                             <ul className="fancy-filter">
                                                <li><a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a></li>
                                                {maketTypeList.map((mktTyp, i) => {
                                                   return (
                                                      <li>
                                                         <a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}><span className="fancynew-budge">{mktTyp.count}</span>{mktTyp.mkt.split("_").join(" ")}</a>
                                                         <a onClick={() => { this.showMarketBetLock(mktTyp) }} className="bk-btn btlock5">BL <i className="fa fa-lock" aria-hidden="true"></i></a>
                                                      </li>
                                                   )
                                                })}
                                             </ul>
                                             <span className="fancyplus-icon" style={{ color: "white" }}><a onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }}>{this.state.showFancy ? <i className="fa fa-minus" aria-hidden="true"></i> : <i className="fa fa-plus" aria-hidden="true"></i>}</a></span>
                                          </div>
                                          <div className="fancybgmobile">
                                             <div className=" fancyscrollmenu" >
                                                <a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a>
                                                <span className="mfancyborderright"></span>
                                                {maketTypeList.map((mktTyp, i) => {
                                                   return (<>
                                                      <a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}>{mktTyp.mkt.split("_").join(" ")}<span className="fancynew-budge">{mktTyp.count}</span></a>
                                                      <a onClick={() => { this.showMarketBetLock(mktTyp) }} className="bk-btn">BL <i className="fa fa-lock" aria-hidden="true"></i></a>
                                                      <span className="mfancyborderright"></span>
                                                   </>)
                                                })}
                                             </div>
                                          </div>
                                          <div style={{ display: this.state.showFancy ? "block" : "none" }} className="table-responsive  game-wrap">
                                             <table className="w-100 analysis-running-market bookmakerfancy fancytable">
                                                <tbody>
                                                   <tr className="bet-all-new">
                                                      <td className="fancyw-65 pb-0">&nbsp;</td>
                                                      <td className="fancyw-20 pb-0 text-center">
                                                         <div>
                                                            <div className="fantitle d-inline">
                                                               <a id="btnBack" className="btn-back bg-trans" side="Back"><span className="ask-price">No</span></a>
                                                            </div>
                                                            <div className="fantitle d-inline">
                                                               <a id="btnLay" className="btn-lay bg-trans" side="Lay"><span className="ask-price">Yes</span></a>
                                                            </div>
                                                         </div>
                                                      </td>
                                                      <td className="fancyw-15 pb-0 p-relative mobile-hide">&nbsp;</td>
                                                   </tr>
                                                   {fancyMarkets.length > 0 && fancyMarkets.map((mkt, i) => {
                                                      let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                                      return (
                                                         <>
                                                            <FancyMarket key={mkt.marketId} consoleRights={this.state.consoleRights} isEventUpdate={this.state.isEventUpdate} isVisible={this.state.isVisible} updateProps={this.state.updateProps} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} mktExpos={this.state.marketExpos} mktAgentExpos={this.state.marketAgentExpos} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} socket={socket} showExpo={(mid, data, agentData, price, lineName) => { this.showExpo(mid, data, agentData, price, lineName) }} curBets={this.state.matched_bet} index={i} type={"ses"} market={mkt} orderCount={!!this.state.mktOrderCount[mkt.marketId] ? this.state.mktOrderCount[mkt.marketId] : 0} openAgentCuttingModal={(mktt) => { this.openAgentCuttingModal(mktt) }}/>
                                                         </>)
                                                   })}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>}
                                 {!!this.state.lineMarkets && this.state.lineMarkets.length > 0 && <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="main-analysis mb-2">
                                          <div className="top">
                                             <div className="toptitle d-inline">Line Markets</div>
                                          </div>
                                          <div className="table-responsive analysis-running-market bookmakerfancy">
                                             <table className="w-100">
                                                <tbody>
                                                   {this.state.lineMarkets.length > 0 && this.state.lineMarkets.map((mkt, i) => {
                                                      return (
                                                         <>
                                                            <FancyMarket key={mkt.marketId} consoleRights={this.state.consoleRights} isEventUpdate={this.state.isEventUpdate} isVisible={this.state.isVisible} updateProps={this.state.updateProps} index={i} type={"line"} market={mkt}  orderCount={!!this.state.mktOrderCount[mkt.marketId] ? this.state.mktOrderCount[mkt.marketId] : 0}  openAgentCuttingModal={(mktt) => { this.openAgentCuttingModal(mktt) }}/>
                                                         </>)
                                                   })}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>}
                                 {/* Winning Odds */}
                                 {!!this.state.oddsMarkets && oddsMarkets.map((mkt, i) => {
                                    if (mkt.marketType !== "WINNING_ODDS") {
                                            return false
                                        }
                                    let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                    return (
                                       <>
                                          <WinnerOdds key={mkt.marketId} consoleRights={this.state.consoleRights} eventType={this.state.eventData.eventType.id} isVisible={this.state.isVisible} updateProps={this.state.updateProps} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mktt) => { this.updateSubscribedMarkets(mktt) }} mktExpos={this.state.marketExpos} mktAgentExpos={this.state.marketAgentExpos} feedBooks={this.state.mktFeedBooks} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} showAvgBookPopup={(mkt, currRunnerId) => { this.showAvgBookPopup(mkt, currRunnerId) }} showMarketBetLock={(mkt) => { this.showMarketBetLock(mkt) }} openUserBooks={(mktId) => { this.openUserBooks(mkt) }} openAgentCuttingModal={(mktId) => { this.openAgentCuttingModal(mkt) }} applyFilter={() => { this.applyFilter(mkt.marketId) }} betFilter={this.state.betFilter} socket={socket} market={mkt} curBets={this.state.matched_bet} orderCount={!!this.state.mktOrderCount[mkt.marketId] ? this.state.mktOrderCount[mkt.marketId] : 0} />
                                       </>)
                                 })}

                                 {/* Tied and Completed match markets */}
                                 {!!this.state.oddsMarkets && oddsMarkets.map((mkt, i) => {
                                    if (mkt.marketType !== "TIED_MATCH" && mkt.marketType !== "COMPLETED_MATCH") {
                                       return false
                                    }
                                    let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                    return (
                                       <>
                                          <WebMarket key={mkt.marketId} consoleRights={this.state.consoleRights} eventType={this.state.eventData.eventType.id} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} mktExpos={this.state.marketExpos} mktAgentExpos={this.state.marketAgentExpos} feedBooks={this.state.mktFeedBooks} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} showAvgBookPopup={(mkt, currRunnerId) => { this.showAvgBookPopup(mkt, currRunnerId) }} showMarketBetLock={(mkt) => { this.showMarketBetLock(mkt) }} openUserBooks={(mktId) => { this.openUserBooks(mkt) }} openAgentCuttingModal={(mktId) => { this.openAgentCuttingModal(mkt) }} applyFilter={() => { this.applyFilter(mkt.marketId) }} betFilter={this.state.betFilter} socket={socket} market={mkt} curBets={this.state.matched_bet} />
                                       </>)
                                 })}
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-5" id="main-analysis-st">
                                 <div className="desktop-tv">
                                    {!!this.state.tvUrl && this.state.tvUrl !== "" && <>
                                       <div className="center-box libtnonoff" >
                                          <p style={{ width: "100%", maxWidth: "100%" }}>
                                             <span style={{ padding: "5px 0px 0px 5px", display: "inline-block" }}>Live TV</span>
                                             <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.liveTvToggle() }} >
                                                <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                                <label className="custom-control-label" for="customSwitches" ></label>
                                             </div>
                                          </p>
                                       </div>
                                       {!!this.state.tvShow && !!this.state.isDesktop && <div className="mb-0 tviframe" style={{ marginTop: "-8px" }} > <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} marginwidth='0' marginheight='0' frameborder='0' width='100%' height='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe></div>}
                                    </>}
                                 </div>
                                 <div className="main-analysis mb-2 ">
                                    <div className="">
                                       <div className="top">
                                          <div className="w-100">
                                             <div className={"d-inline"}>
                                                {!!this.state.eventData.eventType && this.state.eventData.eventType.id !== "400" && this.state.eventData.eventType.id !== "500" && <span className="count">Odds <span className="pl-1 badge two">{this.state.oddCount}</span></span>}
                                                {!!this.state.eventData.eventType && this.state.eventData.eventType.id === "1" && <><span className="count pl-1 pr-1">Under/Over <span className="pl-1 badge two">{this.state.underOverCount}</span></span></>}
                                                <span className="count pl-1 pr-1">BM <span className="pl-1 badge two">{this.state.bmCount}</span></span>
                                                {!!this.state.eventData.eventType && (this.state.eventData.eventType.id === "4" || this.state.eventData.eventType.id === "400" || this.state.eventData.eventType.id === "500") && <><span className="count pl-1">Fancy <span className="pl-1 badge two">{this.state.fancyCount}</span></span></>}
                                                {this.state.bets_data.length > 0 && <a className="matched-btn ml-2 text-white" data-toggle="modal" data-target="#mystatement" onClick={() => { this.applyFilter("") }}>Reset <i class="fa fa-filter ml-1" aria-hidden="true"></i></a>}
                                             </div>
                                             {this.state.bets_data.length > 0 && <a className="matched-btn float-right text-white" data-toggle="modal" data-target="#mystatement" onClick={() => { this.showPopupBets() }}>All Bets <i class="fa fa-list ml-1" aria-hidden="true"></i></a>}
                                             {this.state.bets_data.length > 0 && (!(!!this.state.eventData && !!this.state.eventData.catalogues && this.state.eventData.catalogues.length === 1 && this.state.eventData.catalogues[0].marketType === 'TOURNAMENT_WINNER')) && <a className="matched-btn float-right text-white mr-1" onClick={() => { this.onShowPnLReportMarketPopup() }}>P&amp;L <i class="fa fa-line-chart ml-1" aria-hidden="true"></i></a>}
                                          </div>
                                       </div>
                                       <audio id="beepplay" onClick={this.beepAudioClick}>
                                          <source src={BASE_IMAGE_PATH + "/aimg/beep.mp3"} type="audio/mpeg" />
                                       </audio>
                                       <div className="table-responsive  max-hight">
                                          <table className="w-100 table-sm font-12 text-black whitespace">
                                             <thead className="">
                                                <tr className="bg-dark text-white bg-dark1">
                                                   <td>UserName</td>
                                                   <td>Market</td>
                                                   <td>Runner</td>
                                                   <td>Rate</td>
                                                   <td>Amount</td>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {betList.map((bet, i) => {
                                                   return (
                                                      <>
                                                         {i < this.state.betListLimit && <tr key={i} bgcolor={bet.side === 0 || bet.side === "BACK" ? "#72BBEF" : bet.side === 1 || bet.side === "LAY" ? "#FAA9BA" : ""} style={{ cursor: "pointer" }} onClick={(e) => { this.showUserDetailPopup(bet) }}>
                                                            <td>{bet.username ? bet.username : "-"}</td>
                                                            <td>{!!bet.marketName ? bet.marketName : "-"}</td>
                                                            <td>{!!bet.runnerName ? bet.runnerName + (bet.marketBettingType === "LINE" ? " / " + bet.price : "") : "-"}</td>
                                                            <td className="fbold">{!!bet.price ? bet.price : "0.00"} </td>
                                                            <td className="fbold">{!!bet.amount ? Math.round(bet.amount) : "0.00"}</td>
                                                         </tr>
                                                         }
                                                      </>
                                                   )
                                                })}
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer socket={socket} />
            {this.state.showExpo && <ExpoPopup key={"mktana_expo"} expoPrice={this.state.expoPrice} lineExpo={this.state.lineExpo}  lineAgentExpo={this.state.lineAgentExpo} lineName={this.state.lineName} hidePopup={() => { this.hideExpo() }} />}
            {this.state.showUserDetailPopup &&
               <EventUnsettledBets key={"mktana_usrone"} event_id={this.props.match.params.event_id} market_id={this.state.userDetail.marketId} newPopupData={this.state.newPopupData} newPopupDataClose={() => { this.newPopupData() }} client_id={this.state.userDetail.username} accounts={this.state.accounts} isUserBet={true} hidePopupBets={() => { this.hideUserDetailPopup() }} notify={this.props.notify} eventType={this.state.eventData.eventType}/>
            }
            {this.state.showPopupBets &&
               <EventUnsettledBets key={"mktana_usrall"} event_id={this.props.match.params.event_id} market_id={""} client_id={""} newPopupData={this.state.newPopupData} newPopupDataClose={() => { this.newPopupData() }} accounts={this.state.accounts} isUserBet={false} hidePopupBets={() => { this.hidePopupBets() }} notify={this.props.notify} eventType={this.state.eventData.eventType}/>
            }
            {this.state.openUserBook && this.state.bookMktId !== "" &&
               <UserMarketBook key={"mktana_usrbook"} selectedMarket={this.state.bookMkt} closeUserBook={() => { this.closeUserBook() }} notify={this.props.notify}/>
            }
            {this.state.openAgentCuttingModal && this.state.bookMktId !== "" &&
               <AgentCuttingModal key={"mktana_AgentCuttingModal"} selectedMarket={this.state.agentCuttingMkt} closeAgentCuttingModal={() => { this.closeAgentCuttingModal() }} notify={this.props.notify}/>
            }
            {this.state.avgBookPopup &&
               <AverageMarketBook market={this.state.avgMarket} currRunnerId={this.state.avgCurrRunnerId} hideAvgBookPopup={() => { this.hideAvgBookPopup() }} notify={this.props.notify}/>
            }
            {this.state.showMarketBetLock &&
               <MarketBetLock market={this.state.betLockMkt} event_id={this.props.match.params.event_id} closeMarketBetLock={() => { this.closeMarketBetLock() }} notify={this.props.notify}/>
            }
            {this.state.showPopupUserBook && <>
               <div id="userbook" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">User Book</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupUserBook() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table table-bordered table-sm font-14 tab-ttoptip">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>UserName</th>
                                             <th>Delhi Capitals</th>
                                             <th>Rajasthan Royals</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td><a href="">jackuser</a></td>
                                             <td><a href="">800</a></td>
                                             <td><a href="">-1000</a></td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopupUserBook() }}></div>
               </div>
            </>}
            {this.state.showPopupBetsLock && <>
               <div id="userwise" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-md modal-dialog-centered">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Active User</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupBetsLock() }}>×</button>
                        </div>
                        <div className="modal-body ac-state" >
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="example" className="table table-bordered table-sm font-14 nowrap">
                                       <thead>
                                          <tr>
                                             <th>User Name</th>
                                             <th>Bet Lock</th>
                                             <th>Bet Delay</th>
                                             <th>Password</th>
                                             <th>Action</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td>{!!this.state.marketBetDetail.username ? this.state.marketBetDetail.username : "-"}</td>
                                             <td className="chk-center">
                                                <label className="checkboxx"><input type="checkbox" /><span className="checkmark1"></span></label>
                                             </td>
                                             <td>
                                                <input className="form-control rw-80" type="number" id="userBetDelay" name="userBetDelay" onChange={(e) => { this.onChange(e) }} />
                                             </td>
                                             <td>
                                                <input type="Password" className="form-control rw-150" placeholder="Password" name="masterPassword" onChange={(e) => { this.onChange(e) }} />
                                             </td>
                                             <td>
                                                <button className="btn btn-blue btn-sm">Confirm</button>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop1 fade show" onClick={() => { this.props.hidePopupBetsLock() }}></div>
               </div>
            </>}
            {this.state.showPopupFancyBook && <>
               <div id="book" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Books</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupFancyBook() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table table-bordered table-sm font-14 tab-ttoptip">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>Run</th>
                                             <th>Amount</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr className="oddbg">
                                             <td>54</td>
                                             <td>0.00</td>
                                          </tr>
                                          <tr className="oddbg">
                                             <td>55</td>
                                             <td>0.00</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopupFancyBook() }}></div>
               </div>
            </>}
            {this.state.showMarketBetDetail && <>
               <div id="book" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Bet Detail</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hideMarketBetDetail() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="example" className="w-100 table-sm font-14 text-black mb-2">
                                       <thead className="">
                                          <tr>
                                             <td>User Name</td>
                                             <td>Market</td>
                                             <td>Runner</td>
                                             <td>Side</td>
                                             <td className="text-right">Line</td>
                                             <td className="text-right">Rate</td>
                                             <td className="text-right">Amount</td>
                                             <td title="Potential Profit" className="text-right">PP</td>
                                             <td title="Potential Loss" className="text-right">PL</td>
                                             <td>Time</td>
                                             <td>IP</td>
                                             <td>Device</td>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr className={this.state.marketBetDetail.side === "BACK" ? "laybg" : "oddbg"} >
                                             <td>{!!this.state.marketBetDetail.username ? this.state.marketBetDetail.username : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.marketName ? this.state.marketBetDetail.marketName : this.state.marketBetDetail.marketBettingType}</td>
                                             <td>{!!this.state.marketBetDetail.runnerName ? this.state.marketBetDetail.runnerName : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.side ? this.state.marketBetDetail.side : "-"}</td>
                                             <td className="fbold text-right">{this.state.marketBetDetail.marketBettingType === "LINE" && !!this.state.marketBetDetail.runnerId ? this.state.marketBetDetail.runnerId : "-"}</td>
                                             <td className="fbold text-right">{!!this.state.marketBetDetail.price ? this.state.marketBetDetail.price : "-"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.amount ? <Currency className={"fbold"} amount={this.state.marketBetDetail.amount} showColor={false} /> : "0"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.potentialProfit ? <Currency className={"fbold text-success"} amount={this.state.marketBetDetail.potentialProfit} showColor={false} /> : "0"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.potentialLoss ? <Currency className={"fbold text-red"} amount={this.state.marketBetDetail.potentialLoss} showColor={false} /> : "0"}</td>
                                             <td>{!!this.state.marketBetDetail.createdOn ? new Date(this.state.marketBetDetail.createdOn).toLocaleString() : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.clientIP ? this.state.marketBetDetail.clientIP : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.device ? this.state.marketBetDetail.device : "-"}</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hideMarketBetDetail() }}></div>
               </div>
            </>}
            {this.state.onShowPnLReportMarketPopup && <SettledMarketsPnLModel user_id={this.state.client_id} current_user={this.state.user_id} selectedMarketList={this.state.pnLReportMarkets} hidePopupBets={() => { this.onHidePnLReportMarketPopup() }} sportAnalysisEventDetails={this.state.sportAnalysisEventDetails} onShowPnLReportMarketPopup={() => this.onShowPnLReportMarketPopup()}/>}
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(SportAnalysisUsers);